import { LANGUAGE_EN, LANGUAGE_ES } from '@/services/languages/constants'
import { Language } from '@/services/languages/types'

export const supportedLanguages: Language[] = [LANGUAGE_EN, LANGUAGE_ES]
